import { Navigate } from "react-router-dom";
import authService from "../services/authService";

const PublicRoute = ({ children }) => {
  const isAuth = authService.isLoggedIn();

  if (isAuth) {
    return <Navigate to="/" replace />;
  }

  return children;
};


export default PublicRoute;
